<template>
  <table class="nuttrema-invoice-address" :class="[`is-text-align-${textAlign}`]">
    <tr v-if="title">
      <td>
        {{ title }}
      </td>
    </tr>
    <!-- Invoice form/to person -->
    <template v-if="_isEmpty(_get(PersonInstance, 'InstanceData.company_information_company_name'))">
      <tr>
        <td>
          <strong>{{ _get(Person, 'full_name') }}</strong>
        </td>
      </tr>
      <tr>
        <td>
          {{ _get(Person, 'PersonData.address_street.value') }} {{ _get(Person, 'PersonData.address_house_no.value') }}
        </td>
      </tr>
      <tr>
        <td>
          {{ _get(Person, 'PersonData.address_zip.value') }} {{ _get(Person, 'PersonData.address_city.value') }}
        </td>
      </tr>
      <tr>
        <td>
          <strong>{{ _get(Person, 'Region.name') }}</strong>
        </td>
      </tr>
    </template>
    <!-- Invoice form/to company -->
    <template v-else>
      <tr>
        <td>
          <strong>{{ _get(PersonInstance, 'InstanceData.company_information_company_name.value') }}</strong>
        </td>
      </tr>
      <tr v-if="_has(PersonInstance, 'InstanceData.company_information_vat_number.value')">
        <td>
          {{ $t('label.vat_number') }}: <strong>{{ _get(PersonInstance, 'InstanceData.company_information_vat_number.value') }}</strong>
        </td>
      </tr>
      <tr>
        <td>
          {{ _get(PersonInstance, 'InstanceData.company_information_street.value') }} {{ _get(PersonInstance, 'InstanceData.company_information_house_no.value') }}
        </td>
      </tr>
      <tr>
        <td>
          {{ _get(PersonInstance, 'InstanceData.company_information_zip.value') }} {{ _get(PersonInstance, 'InstanceData.company_information_city.value') }}
        </td>
      </tr>
      <tr>
        <td>
          <strong>{{ _get(PersonInstance, 'Region.name') }}</strong>
        </td>
      </tr>
    </template>
  </table>
</template>

<script>
export default {
  name: 'nuttrema-invoice-address',
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
    textAlign: {
      type: String,
      required: false,
      default: 'left',
    },
    Person: {
      required: true,
      default: null,
    },
    PersonInstance: {
      required: true,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  table {
    &.nuttrema-invoice-address {

      &.is-text-align-right {
        tr {
          td {
            text-align: right;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/info/nuttrema-invoice-address.vue